var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-121.000000, -9.000000)",
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "#ffffff"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Check",
    points: "122.438422 13.7277193 121.941125 14.234686 125.148481 17.4810644 125.526414 17.4810644 131.941125 11.0273305 131.355988 10.4853646 126.243403 15.7390729 125.295895 16.5795865",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/Check-white.702f3a3c57fba176a2ea1348eb2fe6c0.svg";
export { ForwardRef as ReactComponent };